<template>
    <div v-if="!modoVisualizacao">
        <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
        <MensagemAlerta class=" row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

        <div class="form-edit-page row-space">
            <div class="row-start">
                <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentYear'" v-model="dateRange" /></div>
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper">
            <table v-if="globalStore.idep<3">
                <thead>
                    <tr>
                        <th>Protocolos</th>
                        <th>Vistoria</th>
                        <th>SIM</th>
                        <th>Estabelecimento</th>
                        <th>Fiscal</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(pla06, index) in lsDados" :key="pla06.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                        @click="visualizarRegistro(pla06)"
                    >
                        <td class="col-width-char20">{{ pla06.xsequencia }}</td>
                        <td class="col-width-data center">{{ formatDateFromJson(pla06.dtvistoria) }}</td>
                        <td class="col-width-char30">{{ pla06.nmsim }}</td>
                        <td>{{ pla06.nmestabelecimento }}</td>
                        <td class="col-width-char30">{{ pla06.nmvistoriador }}</td>
                    </tr>
                </tbody>
            </table>
            <table v-else>
                <thead>
                    <tr>
                        <th>Protocolo</th>
                        <th>Vistoria</th>
                        <th>SIM</th>
                        <th>Estabelecimento</th>
                        <th>Fiscal</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in lsDados" :key="item.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                        @click="visualizarRegistro(item)"
                    >
                        <td class="col-width-char20">{{ item.protocolo }}</td>
                        <td class="col-width-data center">{{ formatDateFromJson(item.dtvistoria) }}</td>
                        <td class="col-width-char30">{{ item.nmsim }}</td>
                        <td>{{ item.nmestabelecimento }}</td>
                        <td class="col-width-char30">{{ item.nmvistoriador }}</td>
                    </tr>
                </tbody>
            </table>
        </div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>

    <div v-if="modoVisualizacao">
        <div v-if="globalStore.idep<3">
            <Pla06ViewPage :idView="idView" @close="modoVisualizacao = false" />
        </div>
        <div v-else>
            <VistoriaViewPage :idView="idView" @close="modoVisualizacao = false" />
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { formatDateFromJson, validarIntervaloDatas } from '@/funcoes/utils';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import Pla06ViewPage from '../visualizacoes/Pla06ViewPage.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';
import VistoriaViewPage from '../visualizacoes/VistoriaViewPage.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const lsDadosMain = ref([]);
const modoVisualizacao = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try {
        const x = validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        if (x) throw new Error(x);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: globalStore.idestabelecimento,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate
        };
        if (globalStore.idep < 3){
            const req = await genericPost('/lspla/pla06', dados);
            lsDadosMain.value = req;
        }else{
            const r2 = await genericPost('/listas/vistorias', dados);
            lsDadosMain.value = r2;
        }
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
};

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

const visualizarRegistro = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}

onMounted(lerDados);
</script>